import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthCard } from '../components/AuthCard';
import { Input } from '../components/Input';
import { Button } from '../components/Button';
import { CheckCircleIcon } from 'lucide-react';
export const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const handleStep1Submit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle email verification logic here
    console.log('Verify email:', email);
    setStep(2);
  };
  const handleStep2Submit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle OTP verification logic here
    console.log('Verify OTP:', otp);
    setStep(3);
  };
  const handleStep3Submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setPasswordError('Passwords do not match');
      return;
    }
    // Handle password reset logic here
    console.log('Reset password:', password);
    setStep(4);
  };
  const renderStep = () => {
    switch (step) {
      case 1:
        return <form onSubmit={handleStep1Submit} data-id="element-34">
            <Input id="email" label="Email" type="email" placeholder="your@email.com" value={email} onChange={e => setEmail(e.target.value)} required data-id="element-35" />
            <Button type="submit" variant="primary" fullWidth className="mt-4" data-id="element-36">
              Next
            </Button>
          </form>;
      case 2:
        return <form onSubmit={handleStep2Submit} data-id="element-37">
            <p className="text-sm text-gray-500 mb-4" data-id="element-38">
              We've sent a 6-digit code to {email}. Please enter it below.
            </p>
            <Input id="otp" label="Verification Code" placeholder="123456" value={otp} onChange={e => setOtp(e.target.value)} required data-id="element-39" />
            <div className="flex justify-between mt-6" data-id="element-40">
              <Button variant="outline" onClick={() => setStep(1)} data-id="element-41">
                Back
              </Button>
              <Button type="submit" variant="primary" data-id="element-42">
                Verify
              </Button>
            </div>
          </form>;
      case 3:
        return <form onSubmit={handleStep3Submit} data-id="element-43">
            <Input id="password" label="New Password" type="password" placeholder="••••••••" value={password} onChange={e => {
            setPassword(e.target.value);
            setPasswordError('');
          }} required data-id="element-44" />
            <Input id="confirmPassword" label="Confirm Password" type="password" placeholder="••••••••" value={confirmPassword} onChange={e => {
            setConfirmPassword(e.target.value);
            setPasswordError('');
          }} error={passwordError} required data-id="element-45" />
            <div className="flex justify-between mt-6" data-id="element-46">
              <Button variant="outline" onClick={() => setStep(2)} data-id="element-47">
                Back
              </Button>
              <Button type="submit" variant="primary" data-id="element-48">
                Update Password
              </Button>
            </div>
          </form>;
      case 4:
        return <div className="text-center py-8" data-id="element-49">
            <div className="flex justify-center mb-4" data-id="element-50">
              <CheckCircleIcon className="w-16 h-16 text-green-500" data-id="element-51" />
            </div>
            <h2 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-52">
              Password Updated!
            </h2>
            <p className="text-gray-500 mb-6" data-id="element-53">
              Your password has been successfully reset.
            </p>
            <Link to="/" data-id="element-54">
              <Button variant="primary" data-id="element-55">Back to Login</Button>
            </Link>
          </div>;
    }
  };
  const getStepTitle = () => {
    switch (step) {
      case 1:
        return 'Forgot Password';
      case 2:
        return 'Verify Code';
      case 3:
        return 'Create New Password';
      case 4:
        return 'Success';
    }
  };
  const getStepSubtitle = () => {
    switch (step) {
      case 1:
        return 'Enter your email to receive a verification code';
      case 2:
        return 'Enter the verification code sent to your email';
      case 3:
        return 'Create a new password for your account';
      case 4:
        return '';
    }
  };
  return <AuthCard title={getStepTitle()} subtitle={getStepSubtitle()} data-id="element-56">
      {step < 4 && <div className="flex justify-center mb-8" data-id="element-57">
          <div className="flex items-center" data-id="element-58">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center ${step >= 1 ? 'bg-primary-500 text-white' : 'bg-gray-200 text-gray-500'}`} data-id="element-59">
              1
            </div>
            <div className={`w-12 h-1 ${step >= 2 ? 'bg-primary-500' : 'bg-gray-200'}`} data-id="element-60"></div>
            <div className={`w-8 h-8 rounded-full flex items-center justify-center ${step >= 2 ? 'bg-primary-500 text-white' : 'bg-gray-200 text-gray-500'}`} data-id="element-61">
              2
            </div>
            <div className={`w-12 h-1 ${step >= 3 ? 'bg-primary-500' : 'bg-gray-200'}`} data-id="element-62"></div>
            <div className={`w-8 h-8 rounded-full flex items-center justify-center ${step >= 3 ? 'bg-primary-500 text-white' : 'bg-gray-200 text-gray-500'}`} data-id="element-63">
              3
            </div>
          </div>
        </div>}
      {renderStep()}
      {step < 4 && <div className="mt-8 text-center text-sm text-gray-500" data-id="element-64">
          Remembered your password?{' '}
          <Link to="/" className="text-primary-500 hover:text-primary-600 font-medium" data-id="element-65">
            Back to login
          </Link>
        </div>}
    </AuthCard>;
};